// ─── HABIT KEYWORD → EMOJI SUGGESTION (offline auto-suggest) ──────────────────
const HABIT_KEYWORD_MAP = {
  // Fitness & Exercise
  run:"🏃",running:"🏃",jog:"🏃",jogging:"🏃",sprint:"🏃",marathon:"🏃",
  walk:"🚶",walking:"🚶",stroll:"🚶",steps:"🚶",hike:"🏕️",hiking:"🏕️",trek:"🏕️",
  gym:"🏋️",lift:"🏋️",lifting:"🏋️",weights:"🏋️",workout:"🏋️",exercise:"🏋️",train:"🏋️",training:"🏋️",
  swim:"🏊",swimming:"🏊",pool:"🏊",bike:"🚴",cycling:"🚴",cycle:"🚴",bicycle:"🚴",spin:"🚴",
  yoga:"🧘",meditate:"🧘",meditation:"🧘",mindfulness:"🧘",breathe:"🌬️",breathing:"🌬️",
  stretch:"🤸",stretching:"🤸",pilates:"🤸",calisthenics:"🤸",plank:"💪",pushup:"💪",pullup:"💪",squat:"🦵",lunge:"🦵",
  climb:"🧗",climbing:"🧗",skate:"🛹",skating:"🛹",ski:"⛷️",skiing:"⛷️",snowboard:"🏂",
  surf:"🏄",surfing:"🏄",kayak:"🛶",row:"🛶",rowing:"🛶",paddle:"🛶",
  dance:"💃",dancing:"💃",zumba:"💃",aerobics:"🤸",crossfit:"🏋️",hiit:"🔥",
  soccer:"⚽",football:"🏈",basketball:"🏀",tennis:"🎾",badminton:"🏸",volleyball:"🏐",
  boxing:"🥊",martial:"🥋",karate:"🥋",taekwondo:"🥋",judo:"🥋",mma:"🥊",
  golf:"🏌️",baseball:"⚾",cricket:"🏏",rugby:"🏉",
  cardio:"❤️",strength:"💪",endurance:"🏃",flexibility:"🤸",active:"🏃",sport:"🏆",sports:"🏆",
  // Health & Body
  sleep:"😴",sleeping:"😴",rest:"😴",nap:"😴",bedtime:"🛌",bed:"🛌",wake:"☀️",wakeup:"☀️",
  water:"💧",hydrate:"💧",hydration:"💧",fluids:"💧",
  vitamin:"💊",vitamins:"💊",supplement:"💊",medicine:"💊",medication:"💊",pill:"💊",
  doctor:"🩺",checkup:"🩺",dentist:"🦷",therapy:"🧠",therapist:"🧠",
  skincare:"✨",moisturize:"🧴",sunscreen:"☀️",spf:"☀️",facewash:"🧼",
  haircare:"💇",hair:"💇",nails:"💅",manicure:"💅",pedicure:"💅",
  health:"❤️",healthy:"❤️",wellness:"🌿",wellbeing:"🌿",recovery:"🩹",heal:"🩹",healing:"🩹",
  sober:"🚫",sobriety:"🚫",quit:"🚫",quitting:"🚫",detox:"🌿",
  weight:"⚖️",posture:"🦴",back:"🦴",
  // Food & Nutrition
  eat:"🥗",eating:"🥗",meal:"🍽️",meals:"🍽️",diet:"🥗",nutrition:"🥗",food:"🍽️",
  breakfast:"🍳",lunch:"🥙",dinner:"🍽️",snack:"🍎",cook:"🍳",cooking:"🍳",prep:"🍱",mealprep:"🍱",
  vegetable:"🥦",vegetables:"🥦",veggie:"🥦",fruit:"🍎",fruits:"🍎",salad:"🥗",
  protein:"🥩",meat:"🥩",chicken:"🍗",egg:"🥚",eggs:"🥚",
  sugar:"🍬",calorie:"🔥",calories:"🔥",macro:"📊",macros:"📊",
  vegan:"🌱",vegetarian:"🥦",keto:"🥑",paleo:"🥩",fasting:"⏱️",intermittent:"⏱️",
  coffee:"☕",tea:"🍵",juice:"🥤",smoothie:"🥤",shake:"🥤",
  // Mind & Study
  read:"📚",reading:"📚",book:"📚",books:"📚",novel:"📖",study:"📚",studying:"📚",learn:"🎓",learning:"🎓",
  school:"🏫",college:"🎓",university:"🎓",class:"📚",course:"🎓",exam:"📝",homework:"📝",
  write:"✍️",writing:"✍️",journal:"📓",journaling:"📓",diary:"📓",notes:"🗒️",
  research:"🔬",science:"🔬",math:"📐",language:"🗣️",
  podcast:"🎧",listen:"🎧",audiobook:"🎧",
  reflect:"🪞",reflection:"🪞",gratitude:"🙏",thankful:"🙏",appreciate:"🙏",
  focus:"🎯",concentrate:"🎯",memory:"🧠",brain:"🧠",mind:"🧠",
  vocabulary:"📖",flashcard:"🗒️",flashcards:"🗒️",quiz:"📝",
  // Creative
  draw:"🎨",drawing:"🎨",sketch:"✏️",paint:"🖌️",painting:"🖌️",art:"🎨",artwork:"🎨",
  music:"🎵",sing:"🎤",singing:"🎤",guitar:"🎸",piano:"🎹",drums:"🥁",violin:"🎻",instrument:"🎸",
  photo:"📷",photography:"📷",camera:"📷",film:"🎬",video:"🎥",vlog:"🎥",
  craft:"✂️",crafting:"✂️",knit:"🧶",knitting:"🧶",sew:"🧵",sewing:"🧵",crochet:"🧶",
  design:"🖥️",illustrate:"🖌️",illustration:"🖌️",
  poem:"📝",poetry:"📝",story:"📖",blog:"📝",blogging:"📝",
  sculpt:"🏺",pottery:"🏺",ceramic:"🏺",
  // Work & Productivity
  work:"💼",job:"💼",career:"💼",business:"💼",office:"🏢",
  email:"📧",emails:"📧",inbox:"📧",meeting:"🤝",meetings:"🤝",zoom:"💻",standup:"🤝",
  plan:"📋",planning:"📋",schedule:"📅",agenda:"📋",
  task:"✅",tasks:"✅",todo:"✅",checklist:"✅",deadline:"⏰",project:"📊",
  code:"💻",coding:"💻",program:"💻",programming:"💻",develop:"💻",development:"💻",debug:"🔧",
  budget:"💰",finance:"💰",money:"💰",saving:"🏦",invest:"📈",investing:"📈",expense:"💸",expenses:"💸",
  income:"💵",salary:"💵",freelance:"💻",network:"🤝",networking:"🤝",resume:"📄",portfolio:"🗂️",
  productivity:"⚡",goal:"🎯",goals:"🎯",habit:"🌱",habits:"🌱",
  // Social & Relationships
  family:"👨‍👩‍👧",parents:"👨‍👩‍👧",mom:"👩",dad:"👨",friend:"👥",friends:"👥",social:"👥",
  date:"💕",dating:"💕",relationship:"💕",partner:"💕",love:"❤️",romance:"💕",
  volunteer:"🫶",community:"🌍",charity:"🫶",help:"🤲",
  party:"🎉",celebrate:"🎊",
  // Home & Hygiene
  cleaning:"🧹",tidy:"🧹",declutter:"🗑️",laundry:"🧺",dishes:"🍽️",vacuum:"🧹",sweep:"🧹",
  shower:"🚿",bath:"🛁",bathe:"🛁",wash:"🧼",brush:"🦷",teeth:"🦷",floss:"🦷",groom:"💆",
  bake:"🥐",baking:"🥐",grocery:"🛒",groceries:"🛒",shop:"🛍️",shopping:"🛍️",
  repair:"🔧",fix:"🔧",diy:"🔨",garden:"🪴",gardening:"🪴",plant:"🌱",plants:"🌱",
  // Outdoor & Nature
  outdoor:"🌿",outside:"🌿",nature:"🌳",forest:"🌲",park:"🌳",beach:"🏖️",mountain:"🏔️",
  sunrise:"🌅",sunset:"🌇",morning:"☀️",evening:"🌙",night:"🌙",
  camp:"🏕️",camping:"🏕️",fishing:"🎣",stargazing:"🌟",astronomy:"🔭",
  // Lifestyle & Wellness
  selfcare:"🌸",pamper:"🛁",relax:"😌",relaxation:"😌",unwind:"😌",
  grateful:"🙏",affirmation:"💫",affirm:"💫",positive:"🌟",mindset:"🧠",
  screen:"📵",phone:"📵",digital:"📵",
  candle:"🕯️",spa:"🛁",massage:"💆",sauna:"🧖",
  pray:"🙏",prayer:"🙏",faith:"🙏",spiritual:"✨",
  hobby:"🎨",hobbies:"🎨",passion:"🔥",
  // Entertainment
  game:"🎮",gaming:"🎮",watch:"📺",movie:"🎬",movies:"🎬",show:"📺",series:"📺",anime:"📺",
  concert:"🎤",theater:"🎭",museum:"🏛️",
};

// Priority order: higher number = higher priority wins
const EMOJI_PRIORITY = {
  // P5 — time/filler words (lowest)
  "☀️":5,"🌙":5,"🌅":5,"🌇":5,"🌃":5,
  // P4 — lifestyle/social/spiritual
  "😌":4,"🌸":4,"🙏":4,"💕":4,"❤️":4,"🎉":4,"🌍":4,"🤲":4,"✨":4,"💫":4,"🌟":4,
  // P3 — food/home/outdoor
  "🍳":3,"🥗":3,"🍽️":3,"🍎":3,"🥤":3,"☕":3,"🍵":3,"🥙":3,"🍱":3,
  "🧹":3,"🛒":3,"🧺":3,"🪴":3,"🌱":3,"🌿":3,"🌳":3,"🏕️":3,"🎣":3,
  // P2 — creative/work/study
  "🎨":2,"✏️":2,"🖌️":2,"📚":2,"📖":2,"✍️":2,"🎓":2,"🔬":2,"📝":2,"🗒️":2,
  "💼":2,"💻":2,"📊":2,"📋":2,"✅":2,"📧":2,"🤝":2,"💰":2,"📈":2,"🎯":2,
  "🎸":2,"🎹":2,"🎵":2,"🎤":2,"📷":2,"🎬":2,"🧶":2,"✂️":2,"🧵":2,
  "🎮":2,"📺":2,"🎭":2,"🏛️":2,"🎧":2,
  // P1 — fitness/health actions (highest)
  "🏃":1,"🚶":1,"🏋️":1,"🧘":1,"🚴":1,"🏊":1,"🤸":1,"💪":1,"🦵":1,
  "🧗":1,"🛹":1,"⛷️":1,"🏂":1,"🏄":1,"🛶":1,"💃":1,"🥊":1,"🥋":1,
  "⚽":1,"🏀":1,"🎾":1,"🏈":1,"🏌️":1,"🏸":1,"🏐":1,"⚾":1,"🏉":1,"🏏":1,
  "😴":1,"💧":1,"💊":1,"🩺":1,"🦷":1,"⚖️":1,"🩹":1,"🌬️":1,
};

// ─── Restriction trigger words ────────────────────────────────────────────────
const RESTRICTION_TRIGGERS = new Set([
  "no","not","none","never","stop","stopping","stopped",
  "quit","quitting","quitter","avoid","avoiding","avoidance",
  "less","lesser","reduce","reducing","reduction","cut","cutting","cutback",
  "limit","limiting","limits","restricted","restrict","restricting","restriction",
  "free","clean","sober","sobriety","detox","detoxing","abstain","abstaining",
  "without","off","break","breaking","fast","fasting",
]);

// What to show when a restriction word is paired with a specific subject
const RESTRICTION_MAP = {
  // Substances
  alcohol:"🍷", drink:"🍷", drinking:"🍷", beer:"🍺", wine:"🍷", liquor:"🍷", booze:"🍺", drunk:"🍷",
  smoke:"🚬", smoking:"🚬", cigarette:"🚬", cigarettes:"🚬", vape:"🚬", vaping:"🚬", nicotine:"🚬",
  drug:"💊", drugs:"💊", weed:"🌿", cannabis:"🌿",
  caffeine:"☕", coffee:"☕",
  // Food & diet
  sugar:"🍬", sugars:"🍬", sweet:"🍬", sweets:"🍬", candy:"🍬", chocolate:"🍫",
  junk:"🍔", fastfood:"🍔", chips:"🍟", fries:"🍟", soda:"🥤", pop:"🥤", cola:"🥤",
  carb:"🍞", carbs:"🍞", bread:"🍞", gluten:"🍞", dairy:"🥛", meat:"🥩",
  snack:"🍪", snacks:"🍪", binge:"🍽️",
  // Screen & tech
  phone:"📵", phones:"📵", screen:"📵", screens:"📵", social:"📵", media:"📵",
  tiktok:"📵", instagram:"📵", twitter:"📵", facebook:"📵", youtube:"📵",
  game:"🎮", games:"🎮", gaming:"🎮",
  // Habits / behaviors
  porn:"🚫", gambling:"🎰", bet:"🎰", betting:"🎰",
  shopping:"🛍️", spending:"💸", buying:"💸", impulse:"💸",
  procrastinat:"⏰", lazy:"🛋️", laziness:"🛋️",
  nap:"😴", oversleep:"😴", snooze:"😴",
  gossip:"🗣️", complain:"😤", complaining:"😤", negative:"😤", swear:"🤬", swearing:"🤬",
  // Generic fallback (no specific subject found)
  _default: "🚫",
};

export function suggestEmojiFromName(name) {
  if (!name || name.trim().length < 2) return null;
  const words = name.toLowerCase().replace(/[^a-z ]/g, "").trim().split(" ").filter(Boolean);

  // ── Restriction mode: if any word is a restriction trigger ──
  const hasRestriction = words.some(w => RESTRICTION_TRIGGERS.has(w));
  if (hasRestriction) {
    // Always return 🚫 for restriction habits — never the object emoji
    return "🚫";
  }

  // ── Normal mode: collect all matches, pick highest priority ──
  const matches = [];
  for (const word of words) {
    if (HABIT_KEYWORD_MAP[word]) {
      matches.push(HABIT_KEYWORD_MAP[word]);
    } else if (word.length >= 4) {
      const key = Object.keys(HABIT_KEYWORD_MAP).find(k => k.startsWith(word) || word.startsWith(k));
      if (key) matches.push(HABIT_KEYWORD_MAP[key]);
    }
  }

  if (matches.length === 0) return null;

  // Sort by priority (lower number = higher priority), return best match
  matches.sort((a, b) => (EMOJI_PRIORITY[a] ?? 3) - (EMOJI_PRIORITY[b] ?? 3));
  return matches[0];
}
